import * as React from 'react';
import RoutePrivate from '../router/RoutePrivate';
import ProfilePage from './ProfilePage';

export default function getRoutes(isLoggedIn: boolean) {
    return [<RoutePrivate key="profile" path="/profile" component={ProfilePage} isLoggedIn={isLoggedIn} />];
}



// WEBPACK FOOTER //
// ./src/components/profile/Profile.Routes.tsx